export default "__VITE_ASSET__DruRvKUo__"